import ApiClient from './ApiClient';

// check Email sign up exist
export const checkExistEmail = async (
  mail: string,
): Promise<any> => {

  const params = {
    mail,
    siteType: 'HQ'
  };
  const response = await ApiClient.getNoAuth('', `/v1/loginuser/exist`, params);

  return response;
};
